import { Component, OnInit, ViewChild } from '@angular/core';
import { HelpersService } from '../../../../../services/helpers.service';
import { PartnerService } from '../../../../../services/partner.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-import-service-types',
  templateUrl: './import-service-types.component.html',
  styleUrls: ['./import-service-types.component.scss'],
})
export class ImportServiceTypesComponent implements OnInit {
  public partnerID: string;
  public uploading: boolean = false;
  public serviceTypes: any = [];
  public importRecords: any = [];
  public products: any = [];
  public partner: any = {};
  public columns: any = [
    {
      header: this.translate.instant('general.headers.group'),
      field: 'GroupName',
      type: 'string',
    },
    {
      header: this.translate.instant('general.headers.description'),
      field: 'ServiceTypeDescription',
      type: 'string',
    },
    {
      header: this.translate.instant('general.headers.sku'),
      field: 'ServiceSKU',
      type: 'string',
    },
    {
      header: this.translate.instant('general.headers.hours'),
      field: 'Hours',
      type: 'number',
    },
    {
      header: this.translate.instant('general.headers.cost'),
      field: 'Cost',
      type: 'currency',
    },
    {
      header: this.translate.instant('general.headers.import_status'),
      field: 'Status',
      type: 'String',
    },
  ];
  @ViewChild('fileUpload') fileUpload: any;

  constructor(
    public partnerService: PartnerService,
    public helpersService: HelpersService,
    private translate: TranslateService,
  ) {
    this.partnerID = this.helpersService.getPartnerId();
  }

  ngOnInit() {
    this.getServiceTypes();
    this.partner = this.helpersService.getPartnerData();
  }

  getServiceTypes() {
    this.partnerService
      .getPartnerServiceTypesFull(this.partnerID)
      .subscribe((serviceTypes) => {
        this.serviceTypes = serviceTypes;
      });
  }

  importServiceTypes(event) {
    this.products = this.helpersService.getProductData();
    this.importRecords = [];
    let uploadFile = event.target.files[0];
    var reader = new FileReader();
    reader.readAsText(uploadFile);
    reader.onload = (file: any) => {
      var lines = file.target.result.split('\n');
      lines.forEach((line, index, array) => {
        if (index > 0) {
          var columns =
            line.indexOf(',') > -1 ? line.split(',') : line.split(';');
          var matches = this.serviceTypes.filter((item) => {
            return item.ServiceTypeDescription === columns[1];
          });
          if (columns.length >= 3) {
            var cost = 0;
            if (columns[2].length > 0) {
              var product = this.products
                .filter((x) => {
                  return x.SKU === columns[2];
                })
                .pop();
              if (product !== undefined) {
                cost = this.partner.VATInclusive
                  ? product.UnitPrice_IncludingTax
                  : product.UnitPrice;
              }
            }

            let record = {
              Cost:
                cost > 0
                  ? cost
                  : columns[4] && columns[4].trim().length > 0
                    ? parseInt(columns[4].trim())
                    : 0,
              DefaultChecklistItems: [],
              GroupName: columns[0],
              Hours: (parseFloat(columns[3]) / 60).toFixed(2),
              IsActive: true,
              Show: true,
              PartnerID: this.partnerID,
              ServiceTypeDescription: columns[1],
              ServiceSKU: columns[2],
              exists: matches.length > 0,
            };
            this.importRecords.push(record);
          }
        }
      });
    };
    this.fileUpload.nativeElement.value = '';
  }

  importData = async () => {
    for (let i = 0; i < this.importRecords.length; i++) {
      if (!this.importRecords[i].exists) {
        await this.partnerService
          .saveServiceType(this.importRecords[i])
          .subscribe((serviceType) => {
            this.importRecords[i].Status = this.translate.instant(
              'bikeshop.service_types.import.imported',
            );
          });
      } else {
        this.importRecords[i].Status = this.translate.instant(
          'bikeshop.service_types.import.already_exists',
        );
      }
    }
  };
}
